module.exports = __webpack_public_path__ + "media/brands/delorean-8d2f3746.png";